import React from 'react';

interface StatCardProps {
    label: React.ReactNode;
    value: React.ReactNode;
    icon?: React.ReactNode;
    /** Tailwind text color class for the icon bubble, e.g. "text-blue-500". */
    iconClassName?: string;
    /** Small line under the value. */
    hint?: React.ReactNode;
    onClick?: () => void;
}

/**
 * Standard dashboard/list stat tile. Replaces the hand-rolled
 * "rounded-xl border bg-card p-4" variants scattered across dashboards.
 */
const StatCard: React.FC<StatCardProps> = ({ label, value, icon, iconClassName = 'text-primary', hint, onClick }) => (
    <div
        className={`flex items-center gap-3 rounded-xl border border-border bg-card p-4 shadow-sm ${
            onClick ? 'cursor-pointer transition-colors hover:border-primary/50' : ''
        }`}
        onClick={onClick}
    >
        {icon && (
            <div className={`flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-muted/40 text-lg ${iconClassName}`}>
                {icon}
            </div>
        )}
        <div className="min-w-0">
            <div className="text-xs text-muted-foreground">{label}</div>
            <div className="text-xl font-semibold text-foreground">{value}</div>
            {hint && <div className="text-xs text-muted-foreground">{hint}</div>}
        </div>
    </div>
);

export default StatCard;
